import { combineEpics } from "redux-observable";
import { epicOngoingPurchaseCharacterHelpClose } from "./epicOngoingPurchaseCharacterHelpClose";
import { epicOngoingPurchaseCloseAll } from "./epicOngoingPurchaseCloseAll";
export var epicOngoingPurchase = combineEpics(epicOngoingPurchaseCloseAll, epicOngoingPurchaseCharacterHelpClose);



//////////////////
// WEBPACK FOOTER
// ./src/features/ongoing-purchase/epics/epicOngoingPurchase.ts
// module id = 2032
// module chunks = 3